<script setup lang="ts">
import { useLoginStore } from '@/stores/login';
import ProgressSpinner from 'primevue/progressspinner';
import { onMounted } from 'vue';

const loginStore = useLoginStore();

onMounted(() => {
  loginStore.handleOAuthRedirections();
});
</script>

<template>
    <div class="oauth-root">
        <div class="oauth">
            <ProgressSpinner style="width: 32px; height: 32px" strokeWidth="4"/>
            <div>Authenticating using studypages</div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.oauth-root {
    height: 100vh;
}
.oauth {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div {
        margin-top: 16px;
        font-size: 16px;
        font-weight: 600;
    }
}
</style>
